/**
 * Convert a human-written recipe time ("1 hr 30 min", "45 minutes", "1h30m")
 * to an ISO 8601 duration for schema.org markup. ISO input is passed through.
 * Returns undefined for text with no recognisable time.
 */
export function toIsoDuration(value: string): string | undefined {
  const text = value?.trim()
  if (!text) return undefined
  if (/^P(?:\d|T\d)/i.test(text)) return text.toUpperCase()

  let minutes = 0
  let matched = false
  const units: Array<[RegExp, number]> = [
    [/(\d+(?:\.\d+)?)\s*(?:days?|d)\b/gi, 1440],
    [/(\d+(?:\.\d+)?)\s*(?:hours?|hrs?|h)(?![a-z])/gi, 60],
    [/(\d+(?:\.\d+)?)\s*(?:minutes?|mins?|m)(?![a-z])/gi, 1],
  ]
  for (const [pattern, factor] of units) {
    for (const match of text.matchAll(pattern)) {
      minutes += Number(match[1]) * factor
      matched = true
    }
  }
  if (!matched && /^\d+(?:\.\d+)?$/.test(text)) minutes = Number(text)

  minutes = Math.round(minutes)
  if (minutes <= 0) return undefined
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return `PT${hours ? `${hours}H` : ''}${rest ? `${rest}M` : ''}`
}
